module.exports = __webpack_public_path__ + "media/images/blimp_line-775480603c2dedaafb99c496e7fdfa8f.svg";